import { useMemo } from 'react';

import { useIntl } from '@zenbusiness/application-commons-intl';
import PageError from '@zenbusiness/zui/PageError';

import * as Routes from '#client/constants/routes';
import { getVeloLoginReturnUrl } from '#client/utils/veloLoginReturn';

const LoginError = () => {
  const { formatMessage } = useIntl();
  const loginUrl = `${window.location.origin}${Routes.login}`;
  // A login started in Velo goes back to Velo instead of the dashboard login.
  const veloReturnUrl = useMemo(() => getVeloLoginReturnUrl(), []);

  return (
    <PageError
      subtitle={formatMessage({ id: 'dashboard.loginError.description' })}
      showBackButton
      slotProps={{
        backButton: veloReturnUrl
          ? { children: formatMessage({ id: 'dashboard.loginError.backToVelo' }), href: veloReturnUrl }
          : {
              children: formatMessage({ id: 'dashboard.loginError.backToLogin' }),
              href: `/oidc/logout?returnTo=${loginUrl}`,
            },
      }}
    />
  );
};

LoginError.propTypes = {};

export default LoginError;
